var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_c('h2',[_vm._v(_vm._s(_vm.$t("common.hello")))]),_c('h3',[_vm._v(_vm._s(_vm.helloWorld))]),_c('div',[_vm._v("* "+_vm._s(_vm.webapiUrl)+" * "+_vm._s(_vm.environment)+" *")])])}
var staticRenderFns = []

export { render, staticRenderFns }